const BN_DIGITS = ['০', '১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯'];

export const toBn = (value) => String(value).replace(/\d/g, (d) => BN_DIGITS[d]);
export const fromBn = (value) => value.replace(/[০-৯]/g, (d) => BN_DIGITS.indexOf(d));

// Class n (0-based) falls on day 1 + n * gap of the course window.
export function buildSchedule({ totalClasses, classGapDays }) {
  return Array.from({ length: totalClasses }, (_, i) => ({ index: i, day: 1 + i * classGapDays }));
}

// Accepts 01XXXXXXXXX, 8801XXXXXXXXX or +8801XXXXXXXXX (Bangla digits too); returns the 11-digit local form or null.
export function normalizeBdPhone(raw) {
  const digits = fromBn(raw).replace(/[^\d]/g, '').replace(/^88/, '');
  return /^01[3-9]\d{8}$/.test(digits) ? digits : null;
}

// Resolves files in /public so the build also works when hosted under a sub-path. Full URLs pass through.
export const asset = (path) =>
  /^(https?:|data:|\/\/)/.test(path) ? path : `${process.env.PUBLIC_URL}/${path.replace(/^\//, '')}`;
